export class OrderStatusConstants {
  public static isClarificationStatus(statusId: number): boolean {
    return (
      statusId == OrderStatusConstants.OrderStatuses.RefinementOfParameters ||
      statusId == OrderStatusConstants.OrderStatuses.RequiresClarification
    );
  }

  public static isCanReturnToWorkStatus(statusId: number): boolean {
    return statusId == OrderStatusConstants.OrderStatuses.Completed;
  }

  public static isCompletedOrClosed(statusId: number): boolean {
    return statusId == OrderStatusConstants.OrderStatuses.Completed || statusId == OrderStatusConstants.OrderStatuses.Closed;
  }

  public static isCompleted(statusId: number): boolean {
    return statusId == OrderStatusConstants.OrderStatuses.Completed;
  }

  public static isConfirmed(statusId: number): boolean {
    return statusId == OrderStatusConstants.OrderStatuses.Confirmed;
  }

  public static isRequiresImprovement(statusId: number): boolean {
    return statusId == OrderStatusConstants.OrderStatuses.RequiresImprovement;
  }

  public static isForApproval(statusId: number): boolean {
    return statusId == OrderStatusConstants.OrderStatuses.ForApproval;
  }
}

export namespace OrderStatusConstants {
  export enum OrderStatuses {
    RequiresClarification = 265, // Требует уточнения
    Closed = 285, // Закрыт
    RefinementOfParameters = 325, // Уточнение параметров
    ParametersSpecified = 326, // Параметры уточнены

    WaitingForAuthorizationConfirmation = 347, // Ожидание подтверждения полномочий

    ForApproval = 401, // К согласованию
    CancelRequest = 402, // Отмена запроса
    Agreed = 403, // Согласован
    Processed = 404, // Обработан
    DenialOfService = 405, // Отказ в обслуживании
    AppointedToTheHead = 406, // Назначен руководителю
    AcceptedByTheHead = 407, // Принят руководителем
    WaitingForConfirmationOfCosts = 409, // Ожидание подтверждения затрат
    CostsConfirmed = 410, // Затраты подтверждены
    AssignedToPerformer = 411, // Назначен исполнителю
    HiredByThePerformer = 412, // Принят в работу исполнителем

    Completed = 413, // Выполнен
    Confirmed = 415, // Подтвержден
    RequiresImprovement = 416, // Требует доработки

    Confirmed_2 = 419, // Подтвержден
    AssignmentError = 425, // Ошибка назначения
    CostMatchingRequired = 426, // Требуется согласование затрат

    Creating = 545, // Статус создания заявки - черновик

    RequiresConfirmationByITSecurity = 646, // Требует подтверждения СБ ИТ
    PostponedByTheHead = 665, // Отложен руководителем
    Postponed911 = 685, // Отложен 911
    PostponedByThePerformer = 745, // Отложен исполнителем
    WaitingForConfirmationFromITSecurity = 806, // Ожидание подтверждения СБ ИТ
    StageCompleted_911 = 945, // Этап завершен (911)
    SelectingACoordinator = 1025, // Выбор координатора
    StageCompleted_AssignmentToTheHead = 1105, // Этап завершен (назначение руководителю)
    RequiresChangeManagerConfirmation = 2745, // Требует подтверждения Change Manager
    WaitingForChangeManagerConfirmation = 2746, // Ожидание подтверждения Change Manager
  }
}
